module.exports = __webpack_public_path__ + "img/038.b68ea7a4.jpg";